import { render, staticRenderFns } from "./EndpointsHealthy.vue?vue&type=template&id=030085cd&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('030085cd')) {
      api.createRecord('030085cd', component.options)
    } else {
      api.reload('030085cd', component.options)
    }
    module.hot.accept("./EndpointsHealthy.vue?vue&type=template&id=030085cd&", function () {
      api.rerender('030085cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/EndpointsHealthy.vue"
export default component.exports